import { ReactElement } from 'react';
import styles from './no-subscription-banner.module.scss';
import { UIIcon, UIText } from '@/ui';
import { useCompanyContext } from '../providers';
import { Link } from 'react-router';
import { useCompaniesTranslation, useCompanyPermissions } from '../hooks';

export function NoSubscriptionBanner(): ReactElement {
    const { t } = useCompaniesTranslation();
    const { company } = useCompanyContext();

    const { canEditBilling } = useCompanyPermissions();

    if (company.subscription) return <></>;

    if (canEditBilling) {
        return (
            <Link
                to={`/company/${company.id}/settings/billing`}
                className={styles.container}
            >
                <UIIcon name="alert-triangle" size={18} color="white" />
                <UIText variant="semiLarge" type="white" bold>
                    {t('components.no_subscription_banner.can_edit')}
                </UIText>
            </Link>
        );
    } else {
        return (
            <div className={styles.container}>
                <UIIcon name="alert-triangle" size={18} color="white" />
                <UIText variant="semiLarge" type="white" bold>
                    {t('components.no_subscription_banner.cannot_edit')}
                </UIText>
            </div>
        );
    }
}
